(function () {
  'use strict';

  // Guard against re-entrancy: prevents our own cartUpdate publish from triggering another add
  let rw_testerAdding = false;

  subscribe(PUB_SUB_EVENTS.cartUpdate, function (data) {
    if (rw_testerAdding) return;
    if (data.source !== 'product-form') return;

    const checkbox = document.querySelector('[data-rw-tester-variant-id]');
    if (!checkbox || !checkbox.checked) return;

    const variantId = checkbox.dataset.rwTesterVariantId;
    if (!variantId) return;

    rw_testerAdding = true;

    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    if (cart) {
      formData.append('sections', cart.getSectionsToRender().map((s) => s.id));
      formData.append('sections_url', window.location.pathname);
    }
    config.body = formData;

    fetch(routes.cart_add_url, config)
      .then((r) => r.json())
      .then((response) => {
        if (response.status) {
          if (window.location.search.includes('debug_mode=true')) {
            console.warn('[rw-tester] Failed to add tester to cart:', response.description);
          }
          return;
        }
        if (cart) cart.renderContents(response);
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'rw-tester-checkbox',
          productVariantId: variantId,
          cartData: response,
        });
      })
      .catch((e) => {
        if (window.location.search.includes('debug_mode=true')) {
          console.error('[rw-tester] Error adding tester to cart:', e);
        }
      })
      .finally(() => {
        rw_testerAdding = false;
      });
  });
})();
